import { Button, Grid, MenuItem, Table, TableBody, TableCell, TableHead, TableRow, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { patchData } from "src/webService/webService";


export default function EditOutward({ specificOutwardList, handleOutwardClose }) {

    console.log(specificOutwardList, 'specificOutwardListspecificOutwardListspecificOutwardList');

    const [vehicleNo, setVehicleNo] = useState(specificOutwardList?.outwardDeliveryNoteChallan[0]?.vehicleNo);
    const [yourOrderNo, setYourOrderNo] = useState(specificOutwardList?.outwardDeliveryNoteChallan[0]?.yourOrderNo);
    const [customerDcNo, setCustomerDcNo] = useState(specificOutwardList?.outwardDeliveryNoteChallan[0]?.dcNo);
    const [date, setDate] = useState(specificOutwardList?.outwardDeliveryNoteChallan[0]?.date?.split("T")[0]);
    const [batchRemarks, setBatchRemarks] = useState(specificOutwardList?.outwardDeliveryNoteChallan[0]?.batchRemarks);
    const [rows, setRows] = useState([]);
    const [grandTotal, setGrandTotal] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const accessToken = sessionStorage.getItem("Token");


    useEffect(() => {
        const initialRow = specificOutwardList?.outwardDeliveryNoteChallan?.[0]?.outwardTable;
        if (initialRow) {
            setRows([initialRow]);
        }
    }, [specificOutwardList]);

    console.log(rows, 'rowwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww')

    const getTodayDate = () => {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleInputChange = (index, event) => {
        
        const { name, value } = event.target;
        const updatedRows = [...rows[0]];
        updatedRows[index] = {
            ...updatedRows[index],
            [name]: ["rate", "outwardQuantity", "quantity", "initialQuantity", "reducedValue", "totalAmount"].includes(name)
                ? parseFloat(value) || 0
                : value,
        };

        // Auto-update totalAmount if rate or outwardQuantity changes
        if (name === "rate" || name === "outwardQuantity") {
            const rate = updatedRows[index].rate || 0;
            const quantity = updatedRows[index].outwardQuantity || 0;
            updatedRows[index].totalAmount = rate * quantity;
        }

        setRows([updatedRows]);
    };




    useEffect(() => {
        const newGrandTotal = calculateGrandTotal(rows[0]);
        setGrandTotal(newGrandTotal);
        setTotalAmount(calculateTotalAmount(rows[0]));
    }, [rows]);

    const calculateGrandTotal = (rows) => {
        return rows?.reduce(
            (sum, row) => sum + parseFloat(row.outwardQuantity || 0),
            0
        );
    };

    const calculateTotalAmount = (rows) => {
        return rows?.reduce((sum, row) => sum + parseFloat(row.totalAmount || 0), 0);
    };

    console.log(rows, 'rowwwwwwwwwwwww');

    const handleOutwards = async () => {
        if (!date) {
            toast.error("Billing Date is required");
            return;
        }

        const filteredRows = rows[0].filter((row) => row.outwardQuantity > 0);
        if (filteredRows.length === 0) {
            toast.error("Please fill the Outward Qty");
            return;
        }

        const missingRates = filteredRows.filter((row) => !row.rate);
        // const isValueOfGoodsMissing = !valueofGoods;

        if (missingRates.length > 0) {
            toast.error(
                "Please provide either a rate for the Outward Quantity or the Value of Goods"
            );
            return;
        }

        
        const paramsArray = {
            billId: specificOutwardList?.billId,
            clientId: specificOutwardList?.clientId,
            outwardDeliveryNoteChallan: [
                {
                    companyName: specificOutwardList?.outwardDeliveryNoteChallan[0]?.companyName,
                    branch: specificOutwardList?.outwardDeliveryNoteChallan[0]?.branch,
                    dcNo: customerDcNo,
                    date: date,
                    vehicleNo: specificOutwardList?.outwardDeliveryNoteChallan[0]?.vehicleNo,
                    assessmentStartYear: specificOutwardList?.outwardDeliveryNoteChallan[0]?.assessmentStartYear?.split("T")[0],
                    assessmentEndYear: specificOutwardList?.outwardDeliveryNoteChallan[0]?.assessmentEndYear?.split("T")[0],
                    yourOrderNo: specificOutwardList?.outwardDeliveryNoteChallan[0]?.yourOrderNo,
                    yourDcNo: specificOutwardList?.outwardDeliveryNoteChallan[0]?.yourDcNo,
                    valueOfGoods: grandTotal,
                    remainingValueOfGoods: grandTotal,
                    totalAmount: totalAmount?.toFixed(2),
                    batchRemarks: batchRemarks,
                    outwardTable: rows[0]
                        ?.filter((row) => row.outwardQuantity !== 0)
                        ?.map((row) => ({
                            partName: row.partName,
                            partNo: row.partNo,
                            description: row.description,
                            quantity: row.quantity,
                            outwardQuantity: row.outwardQuantity,
                            pendingQuantity: row.outwardQuantity,
                            reducedValue: row.reducedValue,
                            totalWt: row.totalWt,
                            units: row.units,
                            rate: row.rate,
                            totalAmount: row.totalAmount,
                        })),
                },
            ],
        };

        console.log(paramsArray, "paramsArray");

        await patchData(
            `outward/bill/${specificOutwardList?.billId}/outward/${specificOutwardList?._id}`,
            paramsArray,
            accessToken
        )
            .then((res) => {
                console.log(res.data);
                if (res.data) {
                    handleOutwardClose();
                }
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };


    return (
        <>
            <div className="card p-4">
                <div className="component-title">
                    <h5>Edit Outward</h5>
                </div>
                <div>
                    <Grid container spacing={4}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="Company Name"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.companyName}
                                label="Company Name"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{ borderRadius: "15px" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="emailId"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.email}
                                label="Email Id"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                sx={{ borderRadius: "15px" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="mobileNo"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.phoneNumber}
                                label="Mobile Number"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                                sx={{ borderRadius: "15px" }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="gstNo"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.gstNo}
                                label="GST No"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} className="app">
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="branch"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.branch}
                                label="Branch"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="yourDcNo"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.yourDcNo}
                                type="text"
                                label="USF DC No"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{ readOnly: true }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                className="w-100"
                                type="text"
                                label="AssesmentStartYear"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.assessmentStartYear.substring(0, 4)} // Display only the year part
                                size="medium"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                InputProps={{ readOnly: true }}
                            >
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                className="w-100"
                                type="text"
                                label="AssesmentEndYear"
                                value={specificOutwardList?.outwardDeliveryNoteChallan[0]?.assessmentEndYear.substring(0, 4)} // Display only the year part
                                size="medium"
                                InputProps={{ readOnly: true }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            >
                            </TextField>
                        </Grid>
                    </Grid>
                    <Grid container spacing={4} className="app">
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                id="outlined-basic"
                                name="vehicleNo"
                                value={vehicleNo}
                                onChange={(event) => setVehicleNo(event.target.value)}
                                label="Vehicle No"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                required
                                className="w-100"
                                type="date"
                                name="date"
                                label="USF DC Date"
                                value={date}
                                min={getTodayDate()}
                                size="medium"
                                onChange={(event) => setDate(event.target.value)}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                name="yourOrderNo"
                                value={yourOrderNo}
                                onChange={(event) => setYourOrderNo(event.target.value)}
                                label="Purchase Order No"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                name="customerDcNo"
                                value={customerDcNo}
                                onChange={(event) => setCustomerDcNo(event.target.value)}
                                label="Customer DC No"
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                    </Grid>
                </div>
                <Table className="mt-4">
                    <TableHead>
                        <TableRow>
                            <TableCell className="table-cl color-dark">S.NO</TableCell>
                            <TableCell className="table-cl color-dark">Part Name</TableCell>
                            <TableCell className="table-cl color-dark">Part No</TableCell>
                            <TableCell className="table-cl color-dark">Process</TableCell>
                            <TableCell className="table-cl color-dark">Initial Qty</TableCell>
                            <TableCell className="table-cl color-dark">Outward Qty</TableCell>
                            <TableCell className="table-cl color-dark">Rate</TableCell>
                            <TableCell className="table-cl color-dark">Amount</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows[0]?.map((row, index) => (
                            <TableRow key={index}>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={index + 1}
                                        InputProps={{ readOnly: true }}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="partName"
                                        value={row.partName || ''}
                                        onChange={(e) => handleInputChange(index, e)}
                                        InputProps={{ readOnly: true }}

                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="partNo"
                                        value={row.partNo || ''}
                                        onChange={(e) => handleInputChange(index, e)}
                                        InputProps={{ readOnly: true }}

                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="description"
                                        value={row.description || ''}
                                        InputProps={{ readOnly: true }}
                                        onChange={(e) => handleInputChange(index, e)}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="quantity"
                                        type="number"
                                        value={row?.quantity || ''}
                                        onChange={(e) => handleInputChange(index, e)}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="outwardQuantity"
                                        type="number"
                                        value={row.outwardQuantity || ''}
                                        onChange={(e) => handleInputChange(index, e)}
                                        inputProps={{ max: row.initialQuantity }}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="rate"
                                        type="number"
                                        value={row.rate || ''}
                                        onChange={(e) => handleInputChange(index, e)}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        name="totalAmount"
                                        type="number"
                                        value={row.totalAmount?.toFixed(2) || 0}
                                        onChange={(e) => handleInputChange(index, e)}
                                        InputProps={{ readOnly: true }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <div className="d-flex jusity-content-end align-items-center my-2">
                    <p className="mb-0 me-3 col-2" style={{ whiteSpace: "nowrap" }}>
                        Batch Remarks
                    </p>
                    <TextField
                        className="col-3"
                        variant="outlined"
                        value={batchRemarks}
                        onChange={(e) => setBatchRemarks(e.target.value)}
                        onWheel={(e) => e.target.blur()}
                    />
                </div>
                <div>
                    <p>Grand Total: {totalAmount?.toFixed(2)}</p>
                    <p>Total Quantity: {grandTotal}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <p style={{ color: 'red', marginBottom: '0px' }}>⚠️ Ensure that any changes are manually reflected throughout all associated areas</p>

                    <Button
                        variant="contained"
                        onClick={handleOutwards}
                        className="ml-8 btn-primary"
                    >
                        SUBMIT
                    </Button>
                </div>
            </div>
        </>
    )
}